import { FileText, X } from 'lucide-react';

const formatMB = (bytes) => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

export const ReportDownloadProgress = ({ progress, onCancel }) => {
    if (!progress) return null;
    const { loaded, total, phase } = progress;
    const percent = total ? Math.min(100, Math.round((loaded / total) * 100)) : null;
    const generating = phase === 'generating';

    return (
        <div data-testid="report-download-progress" className="fixed bottom-6 right-6 z-50 w-80 bg-[#0a0a0a] border border-[#00FF41]/40 p-4 shadow-lg">
            <div className="flex items-start justify-between gap-3 mb-3">
                <div className="flex items-center gap-2">
                    <FileText className="w-4 h-4 text-[#00FF41]" />
                    <span data-testid="report-download-status" className="text-sm text-white font-medium">
                        {generating ? 'Generazione report in corso…' : 'Download report…'}
                    </span>
                </div>
                <button type="button" data-testid="report-download-cancel-btn" onClick={onCancel} title="Annulla"
                    className="text-white/50 hover:text-white transition-colors">
                    <X className="w-4 h-4" />
                </button>
            </div>
            <div className="h-2 bg-white/10 overflow-hidden">
                {generating || percent === null ? (
                    <div className="h-full w-1/3 bg-[#00FF41] animate-pulse" />
                ) : (
                    <div data-testid="report-download-bar" className="h-full bg-[#00FF41] transition-[width] duration-200" style={{ width: `${percent}%` }} />
                )}
            </div>
            <p data-testid="report-download-detail" className="text-xs text-white/50 mt-2">
                {generating
                    ? 'Il server sta preparando il documento, può richiedere qualche secondo'
                    : percent !== null
                        ? `${percent}% · ${formatMB(loaded)} di ${formatMB(total)}`
                        : formatMB(loaded)}
            </p>
        </div>
    );
};
